var _path, _path2, _path3, _path4, _path5, _linearGradient, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _linearGradient2, _path14, _linearGradient3, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 192,
    height: 192,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7501",
    d: "M33,18v23h5c0-1,0-1.748,0-2.511V18H33z",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7501",
    d: "M32.25,18v23h5.563c-0.452-0.799-0.563-1.748-0.563-2.511V18H32.25z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7501",
    d: "M31.5,18v23h6.126c-0.905-0.598-1.126-1.748-1.126-2.511V18H31.5z",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7501",
    d: "M30.75,18v23h6.69c-1.357-0.397-1.69-1.748-1.69-2.511V18H30.75z",
    opacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7501",
    d: "M30,18v23h7.253C35.443,40.804,35,39.252,35,38.489V18H30z",
    opacity: 0.5
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D3NBlgD7bwuSAzHO257Ipa_Z7XpyPdwISHb_gr1",
    x1: 27.505,
    x2: 16.348,
    y1: 54.084,
    y2: 18.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF6201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#FDBD19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE724"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D3NBlgD7bwuSAzHO257Ipa_Z7XpyPdwISHb_gr1)",
    d: "M33,11H19l-4-4H4C2.9,7,2,7.9,2,9v29.068C2,39.687,3.313,41,4.932,41h32.524 C36.12,41.016,35,39.875,35,38.489V13C35,11.9,34.1,11,33,11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE910D",
    d: "M35,38.489V18H18c-1.1,0-2.62,0.902-3,2c0,0-3.693,13.516-5,18c-0.547,1.877-2.383,3-4,3h31.457 C36.12,41.016,35,39.875,35,38.489z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE910D",
    d: "M35,16H18c-1.794,0-4.174,1.279-4.89,3.345l-0.04,0.128 C13.034,19.607,9.367,33.023,8.08,37.44C7.799,38.403,6.782,41,6,41h29V16z",
    opacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE910D",
    d: "M13.488,19.476c0,0-0.033,0.109-0.037,0.121c-0.094,0.342-3.395,12.417-4.8,17.308 c-0.085,0.294-0.168,0.566-0.255,0.811C8.025,38.765,6.899,41,6,41h29V16.4H18C16.345,16.4,14.137,17.604,13.488,19.476z",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE910D",
    d: "M13.866,19.607c0,0-0.027,0.09-0.034,0.114c-0.152,0.556-3.479,12.723-4.844,17.458 c-0.085,0.293-0.175,0.565-0.277,0.812C8.246,39.125,7.016,41,6,41h29V16.8H18C16.484,16.8,14.448,17.928,13.866,19.607z",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE910D",
    d: "M14.244,19.738c0,0-0.021,0.07-0.031,0.107c-0.211,0.77-3.563,13.029-4.888,17.607 c-0.085,0.292-0.183,0.565-0.298,0.813C8.464,39.484,7.133,41,6,41h29V17.2H18C16.622,17.2,14.759,18.253,14.244,19.738z",
    opacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE910D",
    d: "M14.622,19.869c0,0-0.015,0.051-0.028,0.1c-0.269,0.985-3.647,13.335-4.931,17.757 c-0.085,0.291-0.191,0.564-0.319,0.814C8.678,39.842,7.25,41,6,41h29V17.6H18C16.761,17.6,15.07,18.578,14.622,19.869z",
    opacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE910D",
    d: "M35,18H18c-1.1,0-2.62,0.902-3,2c0,0-3.693,13.516-5,18c-0.547,1.877-2.383,3-4,3h29V18z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D3NBlgD7bwuSAzHO257Ipb_Z7XpyPdwISHb_gr2",
    x1: 10.874,
    x2: 30.525,
    y1: 41.699,
    y2: 18.101,
    gradientTransform: "matrix(-1 0 0 1 47 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F4805D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCFAE",
    stopOpacity: 0.2
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D3NBlgD7bwuSAzHO257Ipb_Z7XpyPdwISHb_gr2)",
    d: "M18,18h27c1.1,0,2,0.9,2,2l-5,18.583 C41.446,39.935,39.918,41,38.583,41H6c1.617,0,3.453-1.123,4-3c1.307-4.484,5-18,5-18C15.38,18.902,16.9,18,18,18z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D3NBlgD7bwuSAzHO257Ipc_Z7XpyPdwISHb_gr3",
    x1: 6,
    x2: 47,
    y1: 29.5,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "ivory",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4805D",
    stopOpacity: 0.4
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D3NBlgD7bwuSAzHO257Ipc_Z7XpyPdwISHb_gr3)",
    d: "M45,18.5c0.807,0,1.466,0.64,1.499,1.438 l-4.973,18.483C41.04,39.57,39.726,40.5,38.583,40.5H8.854c0.731-0.559,1.331-1.349,1.626-2.36 c1.293-4.437,4.965-17.873,4.992-17.976C15.783,19.268,17.122,18.5,18,18.5H45 M45,18H18c-1.1,0-2.62,0.902-3,2 c0,0-3.693,13.516-5,18c-0.547,1.877-2.383,3-4,3h32.583c1.335,0,2.863-1.065,3.417-2.417L47,20C47,18.9,46.1,18,45,18L45,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderColor);
export default __webpack_public_path__ + "static/media/folder_color.b135ce1a4568b17ee7fbf2c2cdb2cf94.svg";
export { ForwardRef as ReactComponent };